import styles from './delete-duration-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IDuration } from '../../../../_models/duration';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteDurationDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  durationId: string
}

export function DeleteDurationDialog(props: DeleteDurationDialogProps) {
  const { data: duration }: { data: IDuration } = useCourseGetRequestHook(`resource/duration/${props.durationId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeleteDuration = () => {
    setLoading(true);
    makeCourseRequest(`resource/duration/delete/${props.durationId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('deleteDuration.deletedDurationFromList'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('deleteDuration.couldNotDeleteDurationFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('deleteDuration.areYouSureYouWantToDeleteDuration')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {duration?.value} {duration?.unit}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteDuration}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteDurationDialog;
